export default __webpack_public_path__ + "8c1ea2697bef48f7427ec5424d266f6a.png";